<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import ViewDetails from './ViewDetails/index.vue';
import InvoicePreview from './InvoicePreview/index.vue';
import confirmationMessage from './confirmationMessage/index.vue';
import informationEntry from './informationEntry/index.vue';
import ConfirmInformationEntry from './ConfirmInformationEntry/index.vue';
import ConfirmationInformationProcessing from './ConfirmationInformationProcessing/index.vue';
import InvoiceIssuedInRed from './InvoiceIssuedInRed/index.vue';
export default {
	components: {
		ViewDetails,
		InvoicePreview,
		confirmationMessage,
		informationEntry,
		ConfirmInformationEntry,
		ConfirmationInformationProcessing,
		InvoiceIssuedInRed
	},
	data() {
		return {
			//红字发票确认信息 我发、发我切换
			isSheifa: true,
			// 红字发票确认信息 表格
			tableData: [{}, {}, {}, {}, {}],
			tablekey: 0,
			shaidiag: false,
			headData: JSON.parse(localStorage.getItem('RedInkInvoiceBusinessheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('RedInkInvoiceBusinessoutlist')) || [],
			// 红字发票记录 表格
			tableDatajl: [{}, {}, {}, {}, {}],
			headDatajl: JSON.parse(localStorage.getItem('RedInkInvoiceBusinessheadDatajl')) || getdata().headDatajl,
			tablekeyjl: 0,
			shaidiagjl: false,
			outlistjl: JSON.parse(localStorage.getItem('RedInkInvoiceBusinessoutlistjl')) || [],
			//查看详情
			HuanqViewDetails: false,
			//预览发票
			HuanqInvoicePreview: false,
			//用于信息确认 信息录入切换 0为主界面 1为确认信息界面 2为信息录入界面 3红字发票确认信息录入 4红字发票确认信息处理 5红字发票开具
			switchInterface: 0
		};
	},
	mounted() {},
	created() {},
	methods: {
		//切换
		switchInterfaceHuanq(e) {
			console.log(e);
			this.switchInterface = e;
		},
		//信息确认 信息录入界面回调
		switchInterfaceHuid(e) {
			this.switchInterface = 0;
		},
		//查看详情回调
		closediagViewDetails(e) {
			this.HuanqViewDetails = false;
		},

		//预览发票回调
		closediagInvoicePreview(e) {
			this.HuanqInvoicePreview = false;
		},

		//红字发票确认信息 表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		//红字发票确认信息 存缓存示例
		confirmfilter(e) {
			localStorage.setItem('RedInkInvoiceBusinessoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('RedInkInvoiceBusinessheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		},
		//红字发票确认信息 表格字段排序
		sortchange(e) {
			console.log(e);
		},
		//红字发票确认信息 显示条数
		sizechange(e) {
			this.pagination.pageSize = e;
		},
		//红字发票确认信息 显示页码
		currentChange(e) {
			this.pagination.pageNum = e;
		},

		//红字发票记录 表格筛选
		closeshaidiagjl() {
			this.shaidiagjl = false;
		},
		//红字发票记录 存缓存示例
		confirmfilterjl(e) {
			localStorage.setItem('RedInkInvoiceBusinessoutlistjl', JSON.stringify(e.nochooselist));
			localStorage.setItem('RedInkInvoiceBusinessheadDatajl', JSON.stringify(e.chooselist));
			this.headDatajl = e.chooselist;
			this.outlistjl = e.nochooselist;
			this.shaidiagjl = false;
			this.$refs.tableboxjl.dout();
			this.tablekeyjl++;
		},
		//红字发票记录 表格字段排序
		sortchangejl(e) {
			console.log(e);
		},
		//红字发票记录 显示条数
		sizechangejl(e) {
			this.paginationjl.pageSize = e;
		},
		//红字发票记录 显示页码
		currentChangejl(e) {
			this.paginationjl.pageNum = e;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
